import { SORT_BY_RELEVANCE_FIELD, SORT_BY_RELEVANCE_ORDER } from '@Constants';

const normalizeSort = (sort) => sort || SORT_BY_RELEVANCE_FIELD;
const normalizeOrder = (order) => order || SORT_BY_RELEVANCE_ORDER;
const normalizePageNumber = (pageNumber) => (pageNumber == null ? pageNumber : String(pageNumber));

export function getSummaryContextMismatchReason(summary, activeBreadcrumb) {
  if (!summary || !activeBreadcrumb) {
    return null;
  }

  const currentResultName = activeBreadcrumb.resultName;
  const validResultNameIndex = summary.validForResultNames?.indexOf(currentResultName) ?? -1;
  if (validResultNameIndex === -1) {
    return 'FILTER';
  }

  // Index 0 is the generation result; later entries are references-only destinations derived
  // from this summary and must remain live regardless of their reset page/sort route defaults.
  if (validResultNameIndex > 0) {
    return null;
  }

  const { sort, order, pageNumber } = summary.sourceResultParams || {};
  const sortChanged = normalizeSort(sort) !== normalizeSort(activeBreadcrumb.sort);
  const orderChanged = normalizeOrder(order) !== normalizeOrder(activeBreadcrumb.order);
  if (sortChanged || orderChanged) {
    return 'SORT';
  }

  const pageChanged =
    pageNumber !== undefined &&
    activeBreadcrumb.pageNumber !== undefined &&
    normalizePageNumber(pageNumber) !== normalizePageNumber(activeBreadcrumb.pageNumber);
  if (pageChanged) {
    return 'PAGE';
  }

  return null;
}

// This helper evaluates only whether the latest successfully generated summary still describes
// the visible result set. Stack ownership is deliberately separate: callers activate only the
// last item in `summaries`, while older completed summaries always have inactive references.
export const isSummaryContextStale = (summary, activeBreadcrumb) => getSummaryContextMismatchReason(summary, activeBreadcrumb) !== null;
